
/**
 * Checks if a given date is a holiday in a specified country using the Holidays API.
 *
 * @param {string} country - The country code (e.g., "US", "CA") for which to check holidays.
 * @param {string} date - The date in "YYYY-MM-DD" format.
 * @returns {Promise<{isHoliday: boolean, holidayName: string} | null>} - A promise that resolves to an object
 * containing holiday information (isHoliday and holidayName) if successful, or null if an error occurs.
 */
const checkIsHoliday = async (country, date) => {
    // Split the date string into year, month, and day parts.
    var dateParts = date.split('-');
    if (dateParts.length !== 3) {
        console.error("Invalid date format given to checkIsHoliday. Expected YYYY-MM-DD");
        return null; // Return null for invalid date format.
    }

    const HOLIDAY_API_KEY = "605888569e014b0395fb671ae74c5734";
    const HOLIDAY_API_URL = `https://holidays.abstractapi.com/v1/?api_key=${HOLIDAY_API_KEY}&country=${country}&year=${dateParts[0]}&month=${dateParts[1]}&day=${dateParts[2]}`;
    
    let holiday_result = {};

    try {
         // Fetch holiday data from the API.
        const response = await fetch(HOLIDAY_API_URL);
    
        // Check if the API request was successful.
        if (!response.ok) {
            console.error("bad response", response.status);
            throw new Error("Holiday api returned HTTP error:", response.status);
        }
        // Parse the JSON response.
        const data = await response.json();
        
        // Check if the API returned any holiday data.
        if (data && data.length > 0) {
            for (const holiday of data) {
                // Only account for national holidays
                if (holiday.type === "National") {
                    holiday_result.isHoliday = true;
                    holiday_result.holidayName = data[0].name; // Get the name of the first holiday returned.
                    return holiday_result;
                }
            }
        }
        // No holiday found for the given date, or they were not national.
        holiday_result.isHoliday = false;
        holiday_result.holidayName = "No holiday";
        return holiday_result;

    } catch (error) {
        // Handle errors during the API request or processing.
        console.error("Failed fetch holiday api data:", error);
        return null; // Return null to indicate an error.
    }
}
export default checkIsHoliday;